import httpClient from '@/http-client'

export const dailyCollectionSchedule = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/daily-collection-schedules',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const disbursementList = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/disbursement-lists', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const summaryOfPortfolioAtRisk = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/summary-of-portfolio-at-risks',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const portfolioRepayment = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/portfolio-repayments', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanOverdue = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/loan-overdues', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanTransactionSummary = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-transaction-summaries',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanTransactionDetail = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/loan-transaction-details', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const customerStatement = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/customer-statements', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanWriteOff = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/loan-write-offs', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanRecovery = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/loan-recoveries', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const loanTransactionSummaryExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-transaction-summaries/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanTransactionSummaryRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-transaction-summaries/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanTransactionDetailExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-transaction-details/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — paginated web report
export const loanTransactionDetailV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-transaction-details-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanTransactionDetailV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-transaction-details-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Transaction Summary (aggregated)
export const loanTransactionSummaryV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-transaction-summaries-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanTransactionSummaryV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-transaction-summaries-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const disbursementListExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/disbursement-lists/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const disbursementListRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/disbursement-lists/excel',
            attributes,
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanWriteOffExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-write-offs/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanRecoveryExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-recoveries/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanRecoveryRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-recoveries/excel',
            attributes,
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanDropOut = (options = {}) => {
    if (options.params.is_as_of_date) {
        return httpClient
            .get('/api/reports/credit-operations/loan-drop-outs-v2', options)
            .then(response => Promise.resolve(response.data))
            .catch(error => Promise.reject(error.response.data))
    }
    return httpClient
        .get('/api/reports/credit-operations/loan-drop-outs', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanDropOutExportExcel = attributes => {
    if (attributes.is_as_of_date) {
        return httpClient
            .post(
                '/api/reports/credit-operations/loan-drop-outs-v2/excel',
                attributes,
                {
                    responseType: 'arraybuffer'
                }
            )
            .then(response => Promise.resolve(response))
            .catch(error => Promise.reject(error.response.data))
    }
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-drop-outs/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanDropOutRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-drop-outs/excel',
            attributes,
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const customerStatementExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/customer-statements/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const customerStatementRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/customer-statements/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const dailyCollectionScheduleExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/daily-collection-schedules/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const dailyCollectionScheduleRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/daily-collection-schedules/excel',
            attributes,
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const summaryOfPortfolioAtRiskExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/summary-of-portfolio-at-risks/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const summaryOfPortfolioAtRiskRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/summary-of-portfolio-at-risks/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const portfolioRepaymentExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/portfolio-repayments/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const portfolioRepaymentRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/portfolio-repayments/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanOverdueExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-overdues/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanOverdueRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-overdues/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanActiveByCo = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/loan-active-by-co', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanPaidOffByCo = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/loan-paid-off-by-co', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanPaidOffByCoExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-paid-off-by-co/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanActiveByCoExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-active-by-co/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanActiveByCoRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-active-by-co/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const incentivePerformanceByCo = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/incentive-performance-by-co',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const incentivePerformanceByCoExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/incentive-performance-by-co/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const devicePostingLogExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/device-posting-logs/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

export const reDisbursementLead = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/re-disbursement-leads', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const reDisbursementLeadExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/re-disbursement-leads/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const reDisbursementLeadRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/re-disbursement-leads/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const staffLoan = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/staff-loan', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const staffLoanExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/staff-loan/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const staffLoanRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/staff-loan/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const cashManagementReport = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/cash-management-report', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const cashManagementReportExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/cash-management-report/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const cashManagementReportRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/cash-management-report/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanSummaryByCustomer = (options = {}) => {
    return httpClient
        .get('/api/reports/credit-operations/loan-summary-by-customers', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanSummaryByCustomerExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-summary-by-customers/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Portfolio Repayment (daily collection performance per CO)
export const portfolioRepaymentV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/portfolio-repayments-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const portfolioRepaymentV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/portfolio-repayments-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Re-disbursement Lead (active loans eligible for a new disbursement)
export const reDisbursementLeadV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/re-disbursement-leads-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const reDisbursementLeadV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/re-disbursement-leads-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Daily Collection Schedule (today's loans to collect, CO | Branch classification)
export const dailyCollectionScheduleV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/daily-collection-schedules-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const dailyCollectionScheduleV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/daily-collection-schedules-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Account Unpaid (today's per-CO unpaid vs paid snapshot, CO | Branch)
export const accountUnpaidV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/account-unpaid-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const accountUnpaidV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/account-unpaid-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Device Posting Log (mobile-device audit log, repayment + recovery)
export const devicePostingLogV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/device-posting-logs-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const devicePostingLogV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/device-posting-logs-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Repayment Loan Overdue (late payments on current loans, CO | Branch)
export const repaymentLoanOverdueV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/repayment-loan-overdues-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const repaymentLoanOverdueV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/repayment-loan-overdues-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Recovery (recovery transactions in a date range, CO | Branch classification)
export const loanRecoveryV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-recoveries-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanRecoveryV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-recoveries-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Written-Off (write-off requests in a date range, CO | Branch classification)
export const loanWrittenOffV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-written-offs-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanWrittenOffV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-written-offs-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Paid-Off (loans finished in a date range, CO | Branch classification)
export const loanPaidOffV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-paid-offs-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanPaidOffV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-paid-offs-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Staff Loan (active loans where loan_type_id = 1)
export const staffLoanV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/staff-loans-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const staffLoanV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/staff-loans-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Disbursement List (loan-level listing, CO | Branch classification)
export const disbursementListV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/disbursement-lists-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const disbursementListV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/disbursement-lists-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Drop Out (window or snapshot mode)
export const loanDropOutV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-drop-outs-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanDropOutV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-drop-outs-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Active by CO (single-date snapshot of active loans)
export const loanActiveByCoV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-active-by-co-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanActiveByCoV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-active-by-co-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Summary of Portfolio at Risk (daily snapshot, 7 PAR buckets)
export const summaryOfPortfolioAtRiskV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/summary-of-portfolio-at-risks-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const summaryOfPortfolioAtRiskV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/summary-of-portfolio-at-risks-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Incentive Performance by CO (monthly snapshot)
export const incentivePerformanceByCoV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/incentive-performance-by-co-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const incentivePerformanceByCoV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/incentive-performance-by-co-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Customer Statement (paginated ledger + PDF)
export const customerStatementV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/customer-statements-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const customerStatementV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/customer-statements-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const customerStatementV3ExportPdf = attributes => {
    // The PDF generator saves the file to storage and returns { url } — we
    // load that URL into the preview iframe rather than a blob.
    return httpClient
        .post(
            '/api/reports/credit-operations/customer-statements-v3/pdf',
            attributes
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Summary of Active Account (paginated + snapshot, CO|Branch)
export const summaryOfActiveAccountV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/summary-of-active-accounts-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const summaryOfActiveAccountV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/summary-of-active-accounts-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Overdue (paginated + snapshot)
export const loanOverdueV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-overdues-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanOverdueV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-overdues-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}

// v3 — Loan Summary By Customer (paginated)
export const loanSummaryByCustomerV3 = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/loan-summary-by-customers-v3',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const loanSummaryByCustomerV3ExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/loan-summary-by-customers-v3/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const accountUnpaid = (options = {}) => {
    return httpClient
        .get(
            '/api/reports/credit-operations/account-unpaid',
            options
        )
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export const accountUnpaidExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/account-unpaid/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const monitoringSurveyExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/monitoring-survey/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const loanOverdueRemarkExportExcel = attributes => {
    return httpClient
        .post(
            "/api/reports/credit-operations/loan-overdue-remarks/excel",
            attributes,
            {
                responseType: "arraybuffer"
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};

export const loanOverdueRemarkRawDataCSV = attributes => {
    return httpClient
        .post("/api/reports/credit-operations/loan-overdue-remarks/excel", attributes)
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data));
};
export const repaymentLoanOverdueExportExcel = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/repayment-loan-overdues/excel',
            attributes,
            {
                responseType: 'arraybuffer'
            }
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export const repaymentLoanOverdueRawDataCSV = attributes => {
    return httpClient
        .post(
            '/api/reports/credit-operations/repayment-loan-overdues/excel',
            attributes
        )
        .then(response => Promise.resolve(response))
        .catch(error => Promise.reject(error.response.data))
}
export default {
    dailyCollectionSchedule,
    disbursementList,
    summaryOfPortfolioAtRisk,
    portfolioRepayment,
    loanOverdue,
    loanTransactionSummary,
    loanTransactionDetail,
    customerStatement,
    loanWriteOff,
    loanRecovery,
    loanTransactionSummaryExportExcel,
    loanTransactionDetailExportExcel,
    loanTransactionDetailV3,
    loanTransactionDetailV3ExportExcel,
    loanTransactionSummaryV3,
    loanTransactionSummaryV3ExportExcel,
    loanSummaryByCustomerV3,
    loanSummaryByCustomerV3ExportExcel,
    loanOverdueV3,
    loanOverdueV3ExportExcel,
    summaryOfActiveAccountV3,
    summaryOfActiveAccountV3ExportExcel,
    customerStatementV3,
    customerStatementV3ExportExcel,
    customerStatementV3ExportPdf,
    incentivePerformanceByCoV3,
    incentivePerformanceByCoV3ExportExcel,
    summaryOfPortfolioAtRiskV3,
    summaryOfPortfolioAtRiskV3ExportExcel,
    portfolioRepaymentV3,
    portfolioRepaymentV3ExportExcel,
    loanActiveByCoV3,
    loanActiveByCoV3ExportExcel,
    loanDropOutV3,
    loanDropOutV3ExportExcel,
    disbursementListV3,
    disbursementListV3ExportExcel,
    staffLoanV3,
    staffLoanV3ExportExcel,
    loanPaidOffV3,
    loanPaidOffV3ExportExcel,
    loanWrittenOffV3,
    loanWrittenOffV3ExportExcel,
    loanRecoveryV3,
    loanRecoveryV3ExportExcel,
    reDisbursementLeadV3,
    reDisbursementLeadV3ExportExcel,
    dailyCollectionScheduleV3,
    dailyCollectionScheduleV3ExportExcel,
    accountUnpaidV3,
    accountUnpaidV3ExportExcel,
    devicePostingLogV3,
    devicePostingLogV3ExportExcel,
    repaymentLoanOverdueV3,
    repaymentLoanOverdueV3ExportExcel,
    disbursementListExportExcel,
    loanWriteOffExportExcel,
    loanRecoveryExportExcel,
    loanDropOut,
    loanDropOutExportExcel,
    customerStatementExportExcel,
    dailyCollectionScheduleExportExcel,
    summaryOfPortfolioAtRiskExportExcel,
    portfolioRepaymentExportExcel,
    loanOverdueExportExcel,
    loanActiveByCo,
    loanActiveByCoExportExcel,
    incentivePerformanceByCo,
    incentivePerformanceByCoExportExcel,
    devicePostingLogExportExcel,
    loanPaidOffByCo,
    disbursementListRawDataCSV,
    loanDropOutRawDataCSV,
    loanRecoveryRawDataCSV,
    dailyCollectionScheduleRawDataCSV,
    loanActiveByCoRawDataCSV,
    customerStatementRawDataCSV,
    summaryOfPortfolioAtRiskRawDataCSV,
    portfolioRepaymentRawDataCSV,
    loanTransactionSummaryRawDataCSV,
    loanOverdueRawDataCSV,
    loanPaidOffByCoExportExcel,
    reDisbursementLead,
    reDisbursementLeadExportExcel,
    reDisbursementLeadRawDataCSV,
    staffLoan,
    staffLoanExportExcel,
    staffLoanRawDataCSV,
    cashManagementReport,
    cashManagementReportExportExcel,
    cashManagementReportRawDataCSV,
    loanSummaryByCustomer,
    loanSummaryByCustomerExportExcel,
    accountUnpaid,
    accountUnpaidExportExcel,
    monitoringSurveyExportExcel,
    loanOverdueRemarkExportExcel,
    loanOverdueRemarkRawDataCSV,
    repaymentLoanOverdueExportExcel,
    repaymentLoanOverdueRawDataCSV
};
